import { f as fetchConfig } from './index-DoPtEJTE.js';

if (!customElements.get('product-form-upsell')) {
  class ProductFormUpsell extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.form = this.querySelector('form');
      if (!this.form) return;

      // Listen on the host so submit is captured after AJAX innerHTML inserts this element
      this.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.productId = this.dataset.productId;
      this.modal =
        this.closest('[data-smart-product-upsell]') ||
        document.querySelector('[data-smart-product-upsell]');
      this.buttonLabel = this.dataset.buttonLabel;
      this.buttonAddedLabel = this.dataset.buttonAddedLabel;
      this.pdpUpsell = this.dataset.pdpUpsell;
      if (!this.pdpUpsell) {
        this.checkProductInCart();
      }
    }
    checkProductInCart() {
      fetch('/cart.js', { method: 'GET' })
        .then((response) => response.json())
        .then((cart) => {
          const productInCart = cart.items.find((item) => item.id == this.productId);
          if (productInCart) {
            this.updateButtonState(true);
          } else if (this.modal) {
            this.modal.classList.remove('hidden');
            this.modal.classList.add('block');
          }
        })
        .catch((e) => {
          console.error('Error checking cart:', e);
        });
    }

    updateButtonState(isInCart) {
      if (isInCart) {
        this.submitButton.textContent = this.buttonAddedLabel;
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('disabled');
      } else {
        this.submitButton.textContent = this.buttonLabel;
        this.submitButton.removeAttribute('disabled');
        this.submitButton.classList.remove('disabled');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.submitButton = this.querySelector('[type="submit"]');

      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      this.cartItems = document.querySelector('cart-items');

      let sectionsToFetch = [];
      if (this.cartNotification) {
        sectionsToFetch = [
          ...this.cartNotification.getSectionsToRender().map((section) => section.section),
        ];
      }

      if (this.cartItems) {
        sectionsToFetch = [
          ...sectionsToFetch,
          ...this.cartItems.getSectionsToRender().map((section) => section.section),
        ];
        // return unique values of array
        sectionsToFetch = [...new Set(sectionsToFetch)];
      }
      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((parsedState) => {
          // When a quantity error is returned
          if (parsedState.status == 422) {
            this.onCartError(parsedState, sectionsToFetch);
            return;
          } else {
            this.onCartSuccess(parsedState);
          }
          // Trigger cart updated event with the latest cart data and sections to render
          this.dispatchEvent(
            new CustomEvent('cart-updated', {
              bubbles: true,
              detail: {
                ...parsedState,
              },
            })
          );
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('disabled');
        });
    }
    // When item is added to the cart
    onCartSuccess(parsedState) {
      if (this.cartDrawer) {
        // Render the returned sections
        this.cartDrawer.renderContents(parsedState);
      }
    }

    // Handle any AddToCart errors
    onCartError(parsedState, sectionsToFetch) {
      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
        this.cartNotification.renderCartError(parsedState.description);
      }

      if (this.cartDrawer) {
        // Let the cart drawer update itself to show all available products are added to the cart
        fetch('/?sections=' + sectionsToFetch.join())
          .then((response) => response.json())
          .then((parsedState) => {
            this.cartDrawer.renderContents({ sections: parsedState });
          });
      }
    }
  }

  window.ProductFormUpsell = ProductFormUpsell;
  customElements.define('product-form-upsell', ProductFormUpsell);
}
